import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/chevron-down.svg?url_encode")